/* eslint-disable no-shadow */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable max-len */
import PropTypes from "prop-types";
import { styled } from "@mui/material";
import { t } from "i18next";

function TaticalAnalysisDesktop({ config }) {
  return (
    <iframe
      width={"100%"}
      height={"100%"}
      src="https://mtrix-pad-tatico.mtrix.com.br"
    ></iframe>
  );
}

TaticalAnalysisDesktop.defaultProps = {
  app: null,
  config: {},
};

TaticalAnalysisDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default TaticalAnalysisDesktop;
